import type { User } from '@/types/user';

// Usuários que NÃO podem ver certas áreas do painel, de forma alguma.
//
// Checagem por id fixo: se a conta for recriada, o id muda e o bloqueio some
// em silêncio — nunca recrie essas contas sem atualizar esta lista.
//
// É bloqueio só no front: o Meta Ads (meta-api) e o Chatbot (ms-chatbot) são
// outros serviços e aceitam o token dessas pessoas. O Status é barrado de
// verdade pela API (admin-only) — por isso essas contas nunca podem ser admin.
//
// Detalhes em api-rocketads/DOCS/contexto/controle-de-acesso.md.

/** 11 = Gino (gino@rocketgroup.io), 29 = Amanda (amanda@matterads.com) */
const SEM_META_ADS = new Set<number>([11, 29]);

/** 11 = Gino (gino@rocketgroup.io), 29 = Amanda (amanda@matterads.com) */
const SEM_CHATBOT = new Set<number>([11, 29]);

export const podeVerMetaAds = (user: User | null): boolean =>
    !user || !SEM_META_ADS.has(user.id);

export const podeVerChatbot = (user: User | null): boolean =>
    !user || !SEM_CHATBOT.has(user.id);
